import { render } from "./HeroiconsOutlineFilter.vue?vue&type=template&id=061c0808"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFilter.vue"]])

export default __exports__